import { Box } from '@mui/material';
import BasicInfoView from './basicInfo';
import PriceComparisonPolicyCompareList from './compareList';
import FooterInfoView from './footer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonPolicyCompareView = function PriceComparisonPolicyCompareView(props) {
  var _info$jove_quote_pric, _info$jove_quote_pric2;

  var info = props.info,
      valueChange = props.valueChange,
      defaultCountry = props.defaultCountry,
      disableSwitchCountry = props.disableSwitchCountry,
      hideCountry = props.hideCountry;
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-col space-y-4",
    children: [/*#__PURE__*/_jsx(BasicInfoView, {
      info: info === null || info === void 0 ? void 0 : info.comparison
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col",
      children: [/*#__PURE__*/_jsx(PriceComparisonPolicyCompareList, {
        info: info,
        valueChange: valueChange,
        defaultCountry: defaultCountry,
        disableSwitchCountry: disableSwitchCountry,
        hideCountry: hideCountry
      }), /*#__PURE__*/_jsx(Box, {
        className: "h-px bg-white"
      }), !!(info !== null && info !== void 0 && (_info$jove_quote_pric = info.jove_quote_price) !== null && _info$jove_quote_pric !== void 0 && (_info$jove_quote_pric2 = _info$jove_quote_pric.aggregate_prices) !== null && _info$jove_quote_pric2 !== void 0 && _info$jove_quote_pric2.jove_commission_discount_amount) && /*#__PURE__*/_jsx(FooterInfoView, {
        info: info
      })]
    })]
  });
};

export default PriceComparisonPolicyCompareView;